<div class="container" [ngClass]="[type]" [class.container--pdf]="pdf">
    @if (!comparation && base?.av?.value) {
        <div
            class="progress"
            [ngClass]="progressClasses"
            [ngStyle]="progressStyle"
        ></div>
    }
    @if (["main", "submain"].includes(type) && !hideExpandButton) {
        <dsn-button-rounded
            [type]="'secondary'"
            [icon]="
                isExpanded
                    ? 'fa-solid fa-chevron-up'
                    : 'fa-solid fa-chevron-down'
            "
            [size]="'medium'"
            (click)="handleExpand.emit()"
            style="position: absolute; right: 8px; top: 2px; z-index: 11"
        ></dsn-button-rounded>
    }
    <div
        fxLayout="column"
        [class.gap-8]="!pdf"
        style="position: relative; z-index: 10"
    >
        <span
            [class]="
                type === 'default'
                    ? 'text-12-regular color-text-petroleum'
                    : 'text-12-semi-bold color-text-petroleum'
            "
            [class.text-10-regular]="pdf && type === 'default'"
            [class.text-10-semi-bold]="pdf && type !== 'default'"
            >{{ serie.name }}</span
        >
        <div [fxLayout]="comparation ? 'row-reverse' : 'row'">
            @if (comparation) {
                <div fxLayout="column" fxLayoutAlign="end start" class="gap-8">
                    <span
                        class="color-text-petroleum"
                        [class.text-10-semi-bold]="pdf"
                        [class.text-12-semi-bold]="!pdf"
                        >{{ comparation.dateFormatted }}</span
                    >
                    <span
                        class="color-text-petroleum"
                        [class.text-10-semi-bold]="pdf"
                        [class.text-12-semi-bold]="!pdf"
                        [appNumberFormatTooltip]="comparation.value"
                        [unit]="
                            serie.unit === 'currency'
                                ? 'numberThousand'
                                : serie.unit
                        "
                        [defaultDecimals]="
                            serie.unit === 'percentage' ? 2 : pdf ? 2 : 0
                        "
                        >{{ comparation.valueFormatted }}</span
                    >
                    @if (comparation.av) {
                        <span
                            class="color-text-hint"
                            [class.text-10-regular]="pdf"
                            [class.text-12-regular]="!pdf"
                            [matTooltip]="comparation.av.explanation"
                            >Análise Vertical:
                            <span
                                class="color-text-cyan-secondary"
                                [class.text-10-semi-bold]="pdf"
                                [class.text-12-semi-bold]="!pdf"
                                >{{ comparation.av.valueFormatted }}</span
                            ></span
                        >
                    }
                </div>
            } @else {
                <div fxLayout="column" fxLayoutAlign="end start">
                    <span
                        class="color-text-hint"
                        [class.text-10-regular]="pdf"
                        [class.text-12-regular]="!pdf"
                        >Análise Vertical:
                        <span
                            class="color-text-cyan-secondary"
                            [class.text-10-semi-bold]="pdf"
                            [class.text-12-semi-bold]="!pdf"
                            >{{ base.av.valueFormatted }}</span
                        ></span
                    >
                </div>
            }
            <span fxFlex></span>
            <div fxLayout="column" fxLayoutAlign="end start" class="gap-8">
                @if (comparation) {
                    <span
                        class="color-text-petroleum"
                        [class.text-10-semi-bold]="pdf"
                        [class.text-12-semi-bold]="!pdf"
                        >{{ base.dateFormatted }}</span
                    >
                }
                <span
                    class="color-text-petroleum"
                    [class.text-10-regular]="type === 'default' && pdf"
                    [class.text-10-semi-bold]="type !== 'default' && pdf"
                    [class.text-12-regular]="type === 'default' && !pdf"
                    [class.text-12-semi-bold]="type !== 'default' && !pdf"
                    [appNumberFormatTooltip]="base.value"
                    [unit]="
                        serie.unit === 'currency'
                            ? 'numberThousand'
                            : serie.unit
                    "
                    [defaultDecimals]="
                        serie.unit === 'percentage' ? 2 : pdf ? 2 : 0
                    "
                    >{{ base.valueFormatted }}</span
                >
                @if (base.av && comparation) {
                    <span
                        class="color-text-hint"
                        [class.text-10-regular]="pdf"
                        [class.text-12-regular]="!pdf"
                        [matTooltip]="base.av.explanation"
                        >Análise Vertical:
                        <span
                            class="color-text-cyan-secondary"
                            [class.text-10-semi-bold]="pdf"
                            [class.text-12-semi-bold]="!pdf"
                            >{{ base.av.valueFormatted }}</span
                        ></span
                    >
                }
            </div>
        </div>
        @if (comparation && ah) {
            <div class="divider"></div>
            <div fxLayout="row">
                <span fxFlex></span>
                <span
                    class="text-10-regular color-text-medium"
                    [matTooltip]="ah.explanation"
                    >Análise Horizontal:
                    <i
                        class="fa-solid"
                        [class.fa-caret-up]="ah.direction === 'up'"
                        [class.fa-caret-down]="ah.direction === 'down'"
                        [class.fa-minus]="ah.direction === 'stable'"
                        [class.text-good]="ah.polarityColor === 'good'"
                        [class.text-bad]="ah.polarityColor === 'bad'"
                        [class.text-stable]="ah.polarityColor === 'stable'"
                    ></i>
                    <span
                        class="text-10-semi-bold"
                        [class.text-good]="ah.polarityColor === 'good'"
                        [class.text-bad]="ah.polarityColor === 'bad'"
                        [class.text-stable]="ah.polarityColor === 'stable'"
                        style="margin-left: var(--spacing-4)"
                        >{{ ah.valueFormatted }}</span
                    ></span
                >
            </div>
        }
    </div>
</div>
